var Handlebars = require('handlebars');
const { LETTER_GROUPS } = require('../models/Constants');

const { __ } =  require('~/data-utils');

const { sanitizeHTML } = require('../protect');
const $ = require('jquery');
const moment = require('moment/min/moment-with-locales');

const svgImage = (name, className) => `
  <img class="${className}" src="/app/imd/dist/sprite.stack.svg#${name}" alt="${name}">`;

const toggleButton = (active, id, icon = id) => `
  <button class="btn btn--toggle btn--overlap ${active ? ' btn--active' : ''}" id="${id}" type="button">
    <span class="btn--toggle__icon icon icon--circle ${active ? ' icon--active' : ''}">
      $${svgImage(`ic_${icon}`, 'icon__img')}
    </span>
  </button>`;


const initHelpers = context => {

  const { resources } = context;

  const svgUse = (name, className = '') => new Handlebars.SafeString(`
    <svg class="${className}">
      <use xlink:href="${resources.get(name)}" href="${resources.get(name)}"></use>
    </svg>`
  );

  const toggleButtonResource = (active, id, icon) => `
    <button class="btn btn--toggle btn--overlap ${active ? ' btn--active' : ''}" id="${id}" type="button">
      <span class="btn--toggle__icon icon icon--circle ${active ? ' icon--active' : ''}">
        ${svgUse(icon, 'icon__img')}
      </span>
    </button>`;
  const toggleListingButtonResource = (active, id, icon) => `
    <button class="btn btn--toggle ${active ? ' btn--active' : ''}" id="${id}" type="button">
      <span class="btn--toggle__listing-icon listing-icon icon--circle ${active ? ' listing-icon--active' : ''}">
        ${svgUse(icon, 'icon__img')}
      </span>
    </button>`;

  Handlebars.registerHelper('svgImage', svgImage);
  Handlebars.registerHelper('toggleButton', toggleButton);

  Handlebars.registerHelper('svgUse', svgUse);
  Handlebars.registerHelper('toggleButtonResource', toggleButtonResource);
  Handlebars.registerHelper('ifEqual', (x,y,value)=> x == y ? value : '');

  Handlebars.registerHelper('expand', function(){
    var expand = '<div class="expand"><div class="expand__arrow"><img class="expand__image" src="/app/imd/dist/sprite.stack.svg#ic_expand"></div></div>';
    return new Handlebars.SafeString(expand);
  });

  Handlebars.registerHelper('langSelect', function(langs, current, disabledLanguages) {

    const langItem = (lang, active) =>
      `<div class="lang-select__lang ${active ? 'lang-select__lang--active' : ''}" id="${lang}">
        ${svgUse(`flag_${lang}--square`, 'lang__icon')}
        <div class="lang__name-short">${lang}</div>
      </div> `;

    const select = langs =>
      `<div class="lang-select">
        ${langs.map(lang => langItem(lang, lang == current)).join('')}
      </div>`;

    const filteredLangs = langs.filter(x => !disabledLanguages.includes(x));

    return filteredLangs.length <= 1 ? '' :
      new Handlebars.SafeString(select(filteredLangs));
  });

  Handlebars.registerHelper('backAndHomeButtons', function() {

    var buttons = [
      toggleButtonResource(true, 'backbutton', 'ic_back'),
      toggleButtonResource(false, 'homebutton', 'ic_home')
    ].join(' ');

    return new Handlebars.SafeString(buttons);
  });

  Handlebars.registerHelper('viewlisting', function(view) {

    var viewlisting = [
      toggleListingButtonResource(view == 'list', 'list', 'ic_list'),
      toggleListingButtonResource(view != 'list', 'logo', 'ic_logo')
    ].join(' ');

    return new Handlebars.SafeString(viewlisting);
  });

  Handlebars.registerHelper('__', function(key) {
    return new Handlebars.SafeString(__(key));
  });

  Handlebars.registerHelper('floormenu', function(floors, currentfloor, imdFloorId, translations, currentLang) {

    const link = (active, youAreHere, id, name) => `
    <li class="list-floor-element list-element ${active ? 'active' : ''}" id="${id}">
        <span class="sidebar__icon"> ${name} </span>
        ${youAreHere ? `
          <div class="list-element__you-are-here">
            ${svgUse('ic_you-are-here', 'you-are-here__icon')}
            <span class="you-are-here__text">&ensp;${translations[currentLang]['map.youAreHere']}</span>
          </div>` : ''
}
    </li> `;

    const floormenu = floors.map(({id, name}) =>
      link(id == currentfloor, id == imdFloorId, id, name)
    ).join('');

    return new Handlebars.SafeString(floormenu);
  });

  Handlebars.registerHelper('wayfindingmenu', (routes, currentRoute, translations, currentLang) => {
    const link = (translations, currentLang, active, route) => {
      return `
        <li id="${route.Num}" class="list-element next-phase ${active ? 'active' : ''}">
          <span class="sidebar__icon">
            ${svgUse(route.GuidingIcon)}
          </span>
          <p>${translations[currentLang][route.Msg]} ${route.TargetFloor ? route.TargetFloor : ''}</p>
        </li>
        `;
    };

    let wayfindingmenu = '';
    routes.forEach(route => wayfindingmenu += link(translations, currentLang, route.Num == currentRoute.Num, route));

    return new Handlebars.SafeString(wayfindingmenu);
  });

  Handlebars.registerHelper('wayfindingNoRoutes', (translations, currentLang) => {
    const noRoutesFound = `<li class="list-element">
          <span class="sidebar__icon">
            <img src="/app/imd/dist/sprite.stack.svg#ic_clock" alt="">
          </span>
          <p>${translations[currentLang]['map.route.notFound']}</p>
        </li>`;
    return new Handlebars.SafeString(noRoutesFound);
  });


  Handlebars.registerHelper('wayfindingFloorChange', (translations, currentLang, imdFloorId, targetFloorId, imdFloorName, targetFloorName, accessibleRoute = false, showAccessibleToggle = false) => {
    const diff = targetFloorId - imdFloorId;

    const icon = (diff > 0) ? 'im_floor-change-up-n' :
      (diff < 0) ? 'im_floor-change-down-n' :
        'im_floor-change-0';

    const goToFloorText = diff != 0 ?
      `${translations[currentLang]['map.route.action.goToFloor']} ${targetFloorName}` :
      translations[currentLang]['map.stayOnSameFloor'];

    const targetFloorLabel = `<span class="infograph__floor"> ${targetFloorName} </span>`;
    const imdFloorLabel = `<span class="infograph__floor"> ${imdFloorName} </span>`;

    const floorBalloons = (diff > 0) ? targetFloorLabel + imdFloorLabel :
      (diff < 0) ? imdFloorLabel + targetFloorLabel :
        targetFloorLabel;

    const accessibleToggle = showAccessibleToggle ? `
      <label class="route-summary__accessible-toggle" for="accessible-route-toggle">
        <span class="route-summary__accessible-toggle-label">${translations[currentLang]['map.route.accessible']}</span>
        <input
          id="accessible-route-toggle"
          type="checkbox"
          class="route-summary__accessible-toggle-input"
          ${accessibleRoute ? 'checked' : ''}
        >
        <span class="route-summary__accessible-toggle-switch" aria-hidden="true"></span>
      </label>
    ` : '';

    const wayfindingFloorChangeElement = `
      <li class="route-summary">
          <span class="route-summary__close">&times;</span>
          <p class="route-summary__title">${translations[currentLang]['map.route']}</p>
          <p class="route-summary__desc">${goToFloorText}</p>
          <div class="route-summary__infograph">
          <div class="infograph__floors">${floorBalloons}</div>
          ${svgUse(icon, 'infograph__img')}
          </div>
          ${accessibleToggle}
        </li>
    `;

    return new Handlebars.SafeString(wayfindingFloorChangeElement);
  });

  Handlebars.registerHelper('svcBtnClasses', (serviceType, activeServiceType) => {
    try {
      const icon = serviceType.icon.replace(/^ic_/, '');
      return Object.entries({
        'service--active': serviceType.id == activeServiceType.id,
        'service--custom': resources.hasCustom(serviceType.icon),
        [`service__${icon}`]: true
      })
        .reduce((acc, [key, include]) => include ? `${acc} ${key}` : acc, '');
    } catch (error) {
      return '';
    }
    
  });

  Handlebars.registerHelper('sortlogos', function(sortby, item, stores, alphabets, currentLetter, officetowers) {
    const listitem = (id, url, name, item, active) => `<li class="list__item list__item--${item} list_ ${active ? 'list__item--active' : 'list__item--inactive'}" id="${id}"><img class="list__item__img" src="${url}" alt="${name}"></li>`;
    const listitem_alternative = (id, name, item, active) => `<li class="list__item list__item--highlight list__item--${item} ${active ? 'list__item--active' : 'list__item--inactive'}" id="${id}"><span>${name}</span></li>`;

    var list = '';

    if (sortby=='name') {

      list = stores.map((store) => {
        if (store.name) {
          const name = removeHtmlTags(parse(store.name));
          const letter = name.charAt(0).toUpperCase();
          const isOther = LETTER_GROUPS.indexOf(letter) < 1;
          const id = isOther ? 'other' : letter;
          const active = !currentLetter || currentLetter == id;

          if (!store.logoURL) {
            return listitem_alternative(store.id, name, id, active);
          }
          else {
            return listitem(store.id, store.logoURL, name, id, active);
          }
        }
      }).join('');

    }else if(sortby == 'floor'){
      if(officetowers=='true'){
        $.each(stores, function(i, store){
          if(store.floor && store.floor.officeTower){
            if(store.floor.officeTowerId == item){
              var name = parse(store.name);
              name = removeHtmlTags(name);
              if(store.logoURL!=undefined && store.logoURL!=''){
                list += listitem(store.id, store.logoURL, name, '', true);
              }else{
                list += listitem_alternative(store.id, name, '', true);
              }
            }
          }
        });
      }else{
        for(var store in stores){
          var name = parse(stores[store].name);
          name = removeHtmlTags(name);
          if(stores[store].floor){
            if(stores[store].floor.id==item){
              if(stores[store].logoURL!=undefined && stores[store].logoURL!=''){
                list += listitem(stores[store].id, stores[store].logoURL, name, '', true);
              }else{
                list += listitem_alternative(stores[store].id, name, '', true);
              }
            }
          }
          if(typeof stores[store].secondaryFloor != 'undefined'){
            if(stores[store].secondaryFloor.id == item){
              if(stores[store].logoURL!=undefined && stores[store].logoURL!=''){
                list += listitem(stores[store].id, stores[store].logoURL, name, '', true);
              }else{
                list += listitem_alternative(stores[store].id, name, '', true);
              }
            }
          }
        }
      }
    }else if(sortby == 'category'){
      for(var store in stores){
        var name = parse(stores[store].name);
        name = removeHtmlTags(name);
        if(stores[store].fieldOfBusinessId == item){
          if(stores[store].logoURL!=undefined && stores[store].logoURL!=''){
            list += listitem(stores[store].id, stores[store].logoURL, name, '', true);
          }else{
            list += listitem_alternative(stores[store].id, name, '', true);
          }
        }
        if(typeof stores[store].additionalFieldOfBusinessIds != 'undefined'){
          $.each(stores[store].additionalFieldOfBusinessIds, function(i, additionalFieldOfBusinessId){
            if(additionalFieldOfBusinessId == item){
              if(stores[store].logoURL!=undefined && stores[store].logoURL!=''){
                list += listitem(stores[store].id, stores[store].logoURL, name, '', true);
              }else{
                list += listitem_alternative(stores[store].id, name, '', true);
              }
            }
          });
        }
      }
    }

    return new Handlebars.SafeString(list);
  });


  Handlebars.registerHelper('alphabets', function(alphabets, stores, letter, view) {
    var list = '';
    const listItem = (alphabet, id, active) => `<li class="nav__button  nav__button ${active ? ' nav__button--active' : ''}" id="${id}"><div class="nav__button__title">${alphabet}</div></li>`;

    if(letter=='other'){
      letter = '#';
    }
    for(var alpha in alphabets){
      var alphabet = alphabets[alpha];
      var id = alphabets[alpha];
      if(alphabet=='#'){
        id = 'other';
      }
      if(letter==alphabet){
        list += listItem(alphabet, id, true);
      }else{
        list += listItem(alphabet, id, false);
      }
    }
    return new Handlebars.SafeString(list);
  });

  Handlebars.registerHelper('sortstores', function(sortby, item, stores, alphabets, officetowers) {
    const listitem = (id, name) => `<li class="list__item" id="${id}">${name}</li>`;
    const ul = (list) => `<ul class="list">${list}</ul>`;
    const group = (ul, title, id) => `<div class="group storelist__group"><h3 id="${id}" class="title storelist__group__title">${title}</h3>${ul}</div>`;

    var filteredStores = {};
    if(sortby=='category'){
      filteredStores = $.map(stores, function(store){
        if(store.fieldOfBusinessId){
          if(store.fieldOfBusinessId==item){
            return store;
          }
        }
        if(typeof store.additionalFieldOfBusinessIds != 'undefined'){
          var additionalStore = null;
          $.each(store.additionalFieldOfBusinessIds, function(i, additionalFieldOfBusinessId){
            if(additionalFieldOfBusinessId==item){
              additionalStore = store;
            }
          });
          if(additionalStore!=null){
            return additionalStore;
          }
        }
      });
    }else if(sortby=='floor'){

      if(officetowers=='true'){
        filteredStores = $.map(stores, function(store){
          if(store.floor){
            if(store.floor.officeTower){
              if(store.floor.officeTowerId==item){
                return store;
              }
            }
          }
        });
      }else{
        filteredStores = $.map(stores, function(store){
          if(store.floor){
            if(store.floor.id==item){
              return store;
            }
          }
          if(typeof store.secondaryFloor != 'undefined'){
            if(store.secondaryFloor.id == item){
              return store;
            }
          }
        });
      }
    }else{
      filteredStores = stores;
    }

    const groups = filteredStores.reduce((acc, store) => {
      if (store.name) {
        const name = removeHtmlTags(parse(store.name));
        const letter = name.charAt(0);

        acc[letter] = (acc[letter] || []).concat(listitem(store.id, name));
        return acc;
      }
    }, {});

    const html = Object.entries(groups).reduce((acc, [letter, listItems]) => {
      const isOther = alphabets.indexOf(letter) < 1;
      const id = isOther ? 'other' : letter;
      const list = ul(listItems.join(''));
      return acc + group(list, letter, id);
    }, '');

    return new Handlebars.SafeString(html);
  });

  Handlebars.registerHelper('sortbyview', function(sortby, array, stores){
    var list = '';

    if(sortby == 'category'){
      const box = (id, num, name) =>
        `<div class="box" id="`+id+`">
          <div class="nav__title"> `+name+`</div>
        </div>`;
      for(var cat in array){
        var count = 0;
        var catid = array[cat].id;
        var catdescription = array[cat].description;

        for(var store in stores){
          if(stores[store].fieldOfBusinessId==catid){
            count++;
          }
          if(stores[store].additionalFieldOfBusinessIds){
            $.each(stores[store].additionalFieldOfBusinessIds, function(i, additionalFieldOfBusinessId){
              if(additionalFieldOfBusinessId==catid){
                count++;
              }
            });
          }
        }

        if(count>0){
          list += box(catid, count, catdescription);
        }
      }
    }else if(sortby=='floor'){
      var box = (id, name) =>
        `<div class="box" id="`+id+`">
          <div class="icon__title nav__title"> `+name+`</div>
        </div>`;

      for(var item in array){
        var { id, name, description } = array[item];
        list +=box(id, name || description);
      }
    }

    return new Handlebars.SafeString(list);
  });

  Handlebars.registerHelper('imagecarousel', function(images){
    const img = (url) => `<span class="bg" style="background-image:url(${url});"></span><img class="offerimage" src="${url}" style="background-color:#fff" alt="default image">`;
    const list = (cl, item, active) => `<li class="${cl} ${active ? ' active' : ''}">${item}</li>`;
    const ul =(cl, list) =>  `<ul class="${cl}">${list}</ul>`;

    var carouselitems = '';
    var indicatoritems = '';

    for (var i in images){
      var image = img(images[i]);
      carouselitems += list('', image, false);
      // if(i==0){
      //   indicatoritems += list('indicator', '<div class="dot"></div>', true);
      // }else{
      //   indicatoritems += list('indicator', '<div class="dot"></div>', false);
      // }
    }

    var carousel = ul('carousel-list', carouselitems);
    // var indicator = ul('carousel-indicator', indicatoritems);

    var html = '<div class="carousel">'+carousel;
    // if(images.length>1){
    //   html += indicator;
    // }

    html += '</div>';
    return new Handlebars.SafeString(html);

  });
  Handlebars.registerHelper('formatOpeningHours', function(openingHours){
    var parsedOpeningHours = openingHours.match(/([a-zA-Zа-яА-ЯåäöøæÅÄÖØÆ]+(-[a-zA-Zа-яА-ЯåäöøæÅÄÖØÆ]+)?\s+([a-zA-Zа-яА-ЯåäöøæÅÄÖØÆ\.\s]+|[0-9]+(\.[0-9]{2})?-[0-9]+(\.[0-9]{2})?(,\s+[0-9]+(\.[0-9]{2})?-[0-9]+(\.[0-9]{2})?)?))/g);
    var string = '<ul class="dotted-list">';

    for(var i = 0; i<parsedOpeningHours.length; i++){
      var trimmed = parsedOpeningHours[i].replace(/\s*,\s*/g, ',').trim();
      var openings = trimmed.split(' ');
      var day = openings[0].replace(/,/g, ' ');
      var time = openings[1];

      if(openings.length > 2){
        for(var j=2; j<openings.length; j++){
          time += ' '+openings[j];
        }
      }

      time = time.replace(/,/g, ' ');
      string += '<li class="dotted-list__item"><span class="left">'+day+'</span><span class="right">'+time+'</span></li>';
    }

    string += '</ul>';
    return new Handlebars.SafeString(string);
  });

  Handlebars.registerHelper('parseOpeningHours', function(day, status, dailyOpeningHours, lang, translations){
    moment.locale(lang);
    let statusTranslated = '';

    if (status === 'CLOSED') {
      statusTranslated = translations[lang]['openingtimes.closed'];
    } else if (status == 'BY_APPOINTMENT') {
      statusTranslated = translations[lang]['openingtimes.by_appointment'];
    }

    var firstDayOfWeek = moment.localeData(lang).firstDayOfWeek();
    const item = (weekday, time) => `<li class="dotted-list__item"><span class="left">${weekday}</span><span class="right">${time}</span></li> `;

    var days = day.split(',');   //Using ECMAScript values Monday = 1, Sunday = 0
    var weekday = moment.weekdaysShort(true, parseInt(days[0]-firstDayOfWeek)); //first of days
    if(days.length > 1){
      weekday += '-'+moment.weekdaysShort(true, parseInt(days[days.length-1]-firstDayOfWeek)); //last of days
    }

    var time = '';
    if(typeof dailyOpeningHours == 'undefined' || $.isEmptyObject(dailyOpeningHours)){
      time = statusTranslated;
    }else{
      $.each(dailyOpeningHours, function (i, openingHours){
        var [toHours, toMinutes] = openingHours.to.split(':');
        var [fromHours, fromMinutes] = openingHours.from.split(':');
        if(toMinutes=='00'){ openingHours.to = toHours; }
        if(fromMinutes=='00'){ openingHours.from = fromHours; }

        time += ' '+openingHours.from+'-'+openingHours.to;
      });
    }

    var string = item(weekday, time);

    return new Handlebars.SafeString(string);
  });

  Handlebars.registerHelper('parseExceptionalOpeningHours', function(date, open, reason, fromHour, fromMinute, toHour, toMinute, lang, translations){
    moment.locale(lang);
    let statusTranslated = '';
    if (open != true) {
      statusTranslated = translations[lang]['openingtimes.closed'];
    }
    var firstDayOfWeek = moment.localeData(lang).firstDayOfWeek();
    var weekday = moment.weekdaysShort(true, parseInt(new Date(date).getDay()-firstDayOfWeek));
    date = moment(date).format('DD.MM');

    var time = '';
    if(open == false) {
      time = statusTranslated;
    }else{
      if(fromMinute == '0') {
        fromMinute = '00';
      }
      if(toMinute == '0'){
        toMinute = '00';
      }
      time += ' '+fromHour+':'+fromMinute+'-'+ toHour+':'+toMinute;
    }

    const item = (weekday, date, reason, time) => `<li class="no-dot-list__item"><span><b>${weekday} ${date},</b> ${reason? reason + ',':''} </span><span>${time}</span></li> `;

    var string = item(weekday, date, reason, time);

    return new Handlebars.SafeString(string);

  });

  Handlebars.registerHelper('formatDate', function(date, lang){
    var parts = date.split('-');
    var year = parts[0];
    var month = parts[1];
    var day = parts[2];

    if(lang == 'fi'){
      date = day+'.'+month+'.'+year;
    }

    return date;
  });

  Handlebars.registerHelper('doubleZeroFormat', function(time, length) {
    length = typeof length == 'number' && time ? length : 2;
    return String(time).padStart(length, '0');
  });

  Handlebars.registerHelper('limitTo', function (arr, limit) {
    if (!Array.isArray(arr)) { return []; }
    return arr.slice(0, limit);
  });

  Handlebars.registerHelper('subArray', function (arr, from, to) {
    if (!Array.isArray(arr)) { return []; }
    return arr.slice(from, to);
  });


  Handlebars.registerHelper('ifEitherExistsThree', function(v1, v2, v3, options) {
    var val1 = ifExists(v1);
    var val2 = ifExists(v2);
    var val3 = ifExists(v3);

    if(val1 || val2 || val3){
      return options.fn(this);
    }else{
      return options.inverse(this);
    }

    function ifExists(val){
      return (val === undefined || val == null || val.length <= 0) ? false : true;
    }
  });

  Handlebars.registerHelper('ifEitherExists', function(v1, v2, options) {
    var val1 = ifExists(v1);
    var val2 = ifExists(v2);

    if(val1 || val2){
      return options.fn(this);
    }else{
      return options.inverse(this);
    }

    function ifExists(val){
      return (val === undefined || val == null || val.length <= 0) ? false : true;
    }
  });

  Handlebars.registerHelper('ifExists', function(v1, options) {
    var val = ifExists(v1);
    if(val){
      return options.fn(this);
    }else{
      return options.inverse(this);
    }

    function ifExists(val){
      return (val === undefined || val == null || val.length <= 0 || $.isEmptyObject(val)) ? false : true;
    }
  });

  Handlebars.registerHelper('svgobject', function(imdfloors, stores, floorid, activeStoreSpaceId){

    var xmlobject;
    for(var floor in imdfloors){
      if(imdfloors[floor].floorId==floorid){
        xmlobject = imdfloors[floor].map;
      }
    }

    var xml = xmlobject,
        xmlDoc = $.parseXML(xml),
        $xml = $(xmlDoc),
        $svg = $xml.find('svg');

    var paths = $svg.find('path');

    var storePaths = '';
    $.map(paths, function(path){
      if(typeof path.id!='undefined' && path.id!=''){
        if(path.id==activeStoreSpaceId){
          $(path).addClass('selected');
        }
        storePaths += path.outerHTML;
      }
    });

    var basePaths = '';
    $.map(paths, function(path){
      if(typeof path.id=='undefined' || path.id==''){
        basePaths += path.outerHTML;
      }
    });

    var base = '<g id="blank">'+basePaths+'</g>';
    var stores = '<g id="stores">'+storePaths+'</g>';

    var html = base+stores;

    return new Handlebars.SafeString(html);
  });

  /**
   * @param {string} content
   */
  function parse(content) {

    if (content && content.length) {
      return new Handlebars.SafeString(sanitizeHTML(content)
        .replace(/<p>&nbsp;<\/p>/gmi, '') // remove empty paragraphs
        .replace(/\r\n/gm, '<br>')        // replace line breaks with br tags
      );
    }
    return content || '';
  }
  Handlebars.registerHelper('parse', parse);

  function removeHtmlTags(content){
    var str = content.string.replace(/<\/?[^>]+(>|$)/g, '');
    return str;
  }

  Handlebars.registerHelper('removeHtmlTags', removeHtmlTags);

  Handlebars.registerHelper('checkLength', function(value, icon){
    var accepted = value;
    if(value.length>2){
      accepted = '<img class="icon__img" src="/app/imd/dist/sprite.stack.svg#'+icon+'" alt="'+icon+'">';
    }
    return new Handlebars.SafeString(accepted);
  });

  Handlebars.registerHelper('checkDirection', function(direction){
    var rotate = direction+90;
    if(rotate > 360){
      rotate = rotate-360;
    }
    return new Handlebars.SafeString(rotate);
  });

  Handlebars.registerHelper('ifShowThumbnailsForEvent', function (event, options) {
    return (event.images && event.images.length > 1) ? options.fn(this) : options.inverse(this);
  });

  Handlebars.registerHelper('getThirdPartyLinkLabel', (thirdPartyLink, langs, currentLang) => {
    const getThirdPartyLinkLabel = ({ label = [] }, langs, currentLang) => {
      const orderedLangs = [].concat(currentLang, langs.filter(x => x != currentLang));
      const labels = orderedLangs.reduce((xs, lang) => {
        const x = label.find(y => y[lang]);
        return x ? xs.concat(x[lang]) : xs;
      }, []);
      return labels[0] || '';
    };

    return new Handlebars.SafeString(getThirdPartyLinkLabel(thirdPartyLink, langs, currentLang));
  });

};

module.exports = {
  initHelpers
};
